import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.084 12.583a.834.834 0 0 0-1.117.375A6.667 6.667 0 1 1 10 3.333a6.61 6.61 0 0 1 5.967 3.709.838.838 0 1 0 1.5-.75 8.334 8.334 0 1 0 0 7.416.834.834 0 0 0-.383-1.125m.416-3.416H9.51l1.916-1.909a.836.836 0 1 0-1.183-1.183L6.909 9.408a.8.8 0 0 0-.175.275.83.83 0 0 0 0 .634q.06.154.175.275l3.333 3.333a.833.833 0 0 0 1.183 0 .833.833 0 0 0 0-1.183L9.51 10.833H17.5a.834.834 0 0 0 0-1.666"
    }, null, -1)
  ])))
}
export default { render: render }